import React, { useEffect } from 'react';
import s from './s.module.less';
import { Input, InputNumber, InputRef } from 'antd';

type Props = React.ComponentProps<typeof Input> & {
    value?: string,
    onChange?: (val: string) => void,
    wrapClass?: string,
    size?: 'large' | 'small' | 'middle',
    needDisplay?: boolean,
    disabled?: boolean,
};

const UsPhoneInput = (props: Props) => {
    const { value, onChange, size = 'middle', needDisplay = true, disabled = false, ...others } = props;
    const [val, setVal] = React.useState('');
    const inputRef = React.useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setVal(value || '');
    }, [value]);

    let display = '';
    if (val && val.length > 0) {
        if (val.length > 7) {
            display = '(';
            for (let i = 0; i < val.length; i++) {
                if (i === 3) {
                    display += ') ';
                } else if (i === 6) {
                    display += '-';
                }
                display += val[i];
            }
        } else {
            for (let i = 0; i < val.length; i++) {
                if (i === 3) {
                    display += '-';
                }
                display += val[i];
            }
        }
    }
    let displayClass = s.sizeNormal;
    if (size === 'large') {
        displayClass = s.sizeLarge;
    }
    if (size === 'small') {
        displayClass = s.sizeSmall;
    }
    let paddingLeft = 10;
    if (val.length > 3) {
        paddingLeft = 20;
    }
    if (val.length > 7) {
        if (size === 'large') {
            paddingLeft = 33;
        } else {
            paddingLeft = 30;
        }
    }
    return (
        <div className={s.wrap}>
            <Input
                ref={(inputElement) => { inputRef.current = inputElement?.input || null; }}
                id="us-phone-input"
                size={size}
                {...others}
                onChange={(e) => {
                    //only allow numbers
                    const newVal = e.target.value.replace(/\D/g, '');
                    setVal(newVal);
                    onChange?.(newVal);
                }}
                className={`${s.input} ${others.className}`}
                style={{
                    paddingLeft: `${paddingLeft}px`,
                }}
                maxLength={10}
                value={val}
                disabled={disabled}
            />
            {needDisplay && <div className={`${s.display} ${displayClass} ${disabled ? s.disabled : ''}`}>{display}</div>}
        </div>
    );
};

export default UsPhoneInput;
